/**
 * Home page Crocs spotlight. Once the section scrolls into view the charms on the clogs pop in
 * one after another (CSS animation keyed on `is-visible`, hidden state keyed on `data-animate`
 * so that without this script the charms are simply shown).
 */
class PufCrocsPromo extends HTMLElement {
  /** @type {IntersectionObserver | undefined} */
  #observer;

  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.setAttribute('data-animate', '');
    this.#observer?.disconnect();
    this.#observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;

        this.classList.add('is-visible');
        this.#observer?.disconnect();
      },
      { threshold: 0.35 }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('puf-crocs-promo')) customElements.define('puf-crocs-promo', PufCrocsPromo);
